/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectRenewalInformationResponse
 */
export interface ProjectRenewalInformationResponse {
    /**
     * 
     * @type {string}
     * @memberof ProjectRenewalInformationResponse
     */
    renewalId: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectRenewalInformationResponse
     */
    conversationId: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectRenewalInformationResponse
     */
    sourceProjectId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectRenewalInformationResponse
     */
    targetQuoteId?: string;
}

/**
 * Check if a given object implements the ProjectRenewalInformationResponse interface.
 */
export function instanceOfProjectRenewalInformationResponse(value: object): value is ProjectRenewalInformationResponse {
    if (!('renewalId' in value) || value['renewalId'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    return true;
}

export function ProjectRenewalInformationResponseFromJSON(json: any): ProjectRenewalInformationResponse {
    return ProjectRenewalInformationResponseFromJSONTyped(json, false);
}

export function ProjectRenewalInformationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectRenewalInformationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'renewalId': json['renewalId'],
        'conversationId': json['conversationId'],
        'sourceProjectId': json['sourceProjectId'] == null ? undefined : json['sourceProjectId'],
        'targetQuoteId': json['targetQuoteId'] == null ? undefined : json['targetQuoteId'],
    };
}

export function ProjectRenewalInformationResponseToJSON(value?: ProjectRenewalInformationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'renewalId': value['renewalId'],
        'conversationId': value['conversationId'],
        'sourceProjectId': value['sourceProjectId'],
        'targetQuoteId': value['targetQuoteId'],
    };
}

